import React, { useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  getAddressInfo,
  getAppId,
  getEmail,
  getStageID,
  setTStageID,
} from "../utility/Common";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import NavBar_appID from "./layout/NavBar_appID";
import { createNotification } from "./Popup";
import { applicationManagement } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import { getResource } from "../utility/services/resources";
import DeclarationReusableComponent from "./declarationReusableComponent";
import CentryReusableComponent from "./CentryReusableComponent";
import { addressInfo } from "../formValidation/FormValidator";

function AnuaniYaSasa() {
  let navigate = useNavigate();
  //const adressInfoData = useLocation();
  // const { DocStageID } = adressInfoData.state || {};
  // var Stage = adressInfoData?.state?.DocStageID;
  const [selectedCountries, setSelectedCountries] = useState("");
  const [stageId, setStageId] = useState();
  const [stageID, setStageID] = useState(null); //additional
  const { checkApplicationStage } = CentryReusableComponent({});
  const [BirthVillage, setBirthVillage] = useState("");
  const [HouseNumber, setHouseNumber] = useState("");
  const [countries, setCountries] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [territoryID, setTerritoryID] = useState();
  const [countryId, setCountryID] = useState();
  const [regions, setRegions] = useState([]);
  const [regionsId, setRegionID] = useState();
  const [districts, setDistricts] = useState([]);
  const [districtsId, setDistrictsID] = useState();
  const [wards, setWards] = useState([]);
  const [wardsId, setWardsID] = useState();
  const [errors, setErrors] = useState();
  const { isdeclarationLoading, handleApplicationManagement } =
    DeclarationReusableComponent({
      applicationManagement,
    });

  const [isLoading, setIsLoading] = useState(false);
  //======Lookups
  useEffect(() => {
    fetchCountries();
    setAddressInfo();
  }, []);

  const setAddressInfo = () => {
    const data = getAddressInfo();
    checkApplicationStage(1);
    setStageId(data?.DocStageID);
    setStageID(data?.DocStageID); //additional

    setCountryID(+data?.ResidenceCountryID);
    setSelectedCountries(+data?.ResidenceCountryID);

    if (+data?.countryID) {
      setCountryID(+data?.ResidenceDistrictID);
    }

    setTerritoryID(+data?.ResidenceTerritoryID);
    if (+data?.ResidenceCountryID) {
      fetchTerritory(+data?.ResidenceCountryID);
    }

    setRegionID(+data?.ResidenceRegionID);
    if (+data?.ResidenceTerritoryID) {
      fetchRegions(+data?.ResidenceTerritoryID, +data?.ResidenceCountryID);
    }

    setDistrictsID(+data?.ResidenceDistrictID);
    if (+data?.ResidenceRegionID) {
      fetchDistricts(+data?.ResidenceRegionID);
    }

    setWardsID(+data?.ResidenceWardID);
    if (+data?.ResidenceWardID) {
      fetchDistricts(+data?.ResidenceWardID);
    }

    setBirthVillage(data?.ResidenceVillage);
    setHouseNumber(data?.HouseNumber);
  };

  //======fetchCountries
  const fetchCountries = async () => {
    const result = await getResource("Country", "null", "null", "lookup");
    if (Array.isArray(result) && result.length > 0) {
      setCountries(result);
    } else {
      setCountries([]);
    }
  };

  //======selectCountry
  const getCountryIDChange = (e) => {
    const countryID = e.target.value;
    setCountryID(countryID);
    setWardsID(countryID);
    fetchTerritory(countryID);
  };
  const fetchTerritory = async (territoryId) => {
    const result = await getResource(
      "TerritoryByCountry",
      territoryId,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setTerritories(result);
    } else {
      setTerritories([]);
    }
  };

  //======selectTerritory
  const getTerritoryIDChange = (e) => {
    const territoryID = e.target.value;
    setTerritoryID(territoryID);
    fetchRegions(territoryID, countryId);
  };

  const fetchRegions = async (territoryID, countryID) => {
    const result = await getResource(
      "RegionBirth",
      territoryID,
      countryID,
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setRegions(result);
    } else {
      setRegions([]);
    }
  };

  //======selectRegion
  const getRegionIDChange = (e) => {
    const regionID = e.target.value;
    setRegionID(regionID);
    fetchDistricts(regionID);
  };
  const fetchDistricts = async (regionID) => {
    const result = await getResource(
      "DistrictByRegionID",
      regionID,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setDistricts(result);
    } else {
      setDistricts([]);
    }
  };

  //======selectDistrict
  const getDistrictIDChange = (e) => {
    const districtID = e.target.value;
    setDistrictsID(districtID);
    fetWards(districtID);
  };
  const fetWards = async (districtId) => {
    const result = await getResource(
      "WardByDistrict",
      districtId,
      "null",
      "lookup",
    );
    if (Array.isArray(result) && result.length > 0) {
      setWards(result);
    } else {
      setWards([]);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (getStageID() == 100) {
      const formData = {
        Action: "Insert",
        ApplicationId: getAppId(),
        HouseNumber: HouseNumber,
        ResidenceDistrictID: districtsId,
        ResidenceVillage: BirthVillage,
        EmailAddress: getEmail(),
      };

      const newErrors = addressInfo(formData);
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setIsLoading(true);

        applicationManagement(formData, "add-address-info")
          .then((result) => {
            setIsLoading(false);
            if (result.code == 1) {
              console.log(result.data, "anuani ya sasa");
              if (result.data) {
                const stID = result.data[0]?.StageID;
                setTStageID(stID);
              }
              navigate("/taarifa_za_safari");
              const info = { type: "success", message: result.message };
              createNotification(info)();
            } else {
              const info = { type: "error", message: result.message };
              createNotification(info)();
            }
          })
          .catch((error) => {
            setIsLoading(false);
            const info = { type: "error", message: messages.networkError };
            createNotification(info)();
          });
      }
    } else {
      const formData = {
        Action: "Update",
        ApplicationId: getAppId(),
        HouseNumber: HouseNumber,
        ResidenceDistrictID: districtsId,
        ResidenceVillage: BirthVillage,
        TravellingPurposeID: "",
        EmailAddress: getEmail(),
      };
      applicationManagement(formData, "add-address-info")
        .then((result) => {
          if (result.code == 1) {
            if (result.data) {
              const stID = result.data[0]?.DocStageID;
              setTStageID(stID);

              const info = { type: "success", message: result.message };
              const stages = result.data[0];
              switch (stID) {
                case 110:
                  // navigate("/taarifa_za_safari");
                  navigate("/taarifa_za_safari", { state: stages });
                  createNotification(info)();
                  break;
                case 120:
                  const decPaylod = {
                    Action: "",
                    ApplicationId: getAppId(),
                    HouseNumber: HouseNumber,
                    ResidenceDistrictID: districtsId,
                    ResidenceVillage: BirthVillage,
                    EmailAddress: getEmail(),
                  };
                  handleApplicationManagement(decPaylod, "declaration");
                  break;

                case 130:
                  navigate("/stp10");
                  createNotification(info)();
                  break;

                case 140:
                  navigate("/stp10");
                  createNotification(info)();
                  break;

                case 150:
                  navigate("/stp10");
                  createNotification(info)();
                  break;

                case 160:
                  navigate("/stp10");
                  createNotification(info)();
                  break;

                default:
                  navigate("/continue");
              }
            } else if (result.code == 3) {
              sessionStorage.clear();
              localStorage.clear();
              navigate("/continue");
            } else {
              const info = { type: "error", message: result.message };
              createNotification(info)();
            }
          }
        })
        .catch((error) => {
          const info = { type: "error", message: messages.networkError };
          createNotification(info)();
        });
    }
  };
  const endeleaBadae = () => {
    navigate("/");
  };
  const nyuma = () => {
    navigate("/continue");
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link Link className="list-group-item done">
                    Habari Binafsi{" "}
                  </Link>
                  <Link className="list-group-item active">
                    Anuwani ya Makazi
                  </Link>
                  <Link className="list-group-item ">Habari za Wazazi </Link>
                  <Link className="list-group-item ">Habari za Safari</Link>
                  <Link className="list-group-item ">Wakati wa Dharura</Link>
                  <Link className="list-group-item ">Viambatanisho </Link>
                  <Link className="list-group-item ">Tamko Rasmi </Link>
                  <Link className="list-group-item ">Kamilika </Link>
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "1px" }}
              >
                <div className="tab-registration-content active">
                  <form id="step-two-form" onSubmit={handleSubmit}>
                    <div className="box box-default">
                      <div className="box-header with-border">
                        <h3 className="box-title">Anuani ya Makazi</h3>
                      </div>
                      <div className="box-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthCountryID"
                              >
                                Nchi
                              </label>
                              <select
                                id="BirthCountryID"
                                className="form-control"
                                name="BirthCountryID"
                                onChange={getCountryIDChange}
                                value={countryId}
                                required
                              >
                                <option value="">Chagua Nchi</option>
                                {countries.length > 0 &&
                                  countries?.map((country) => (
                                    <option
                                      key={country.id}
                                      value={country.ResourceID}
                                    >
                                      {country.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthTerritoryID"
                              >
                                Eneo
                              </label>

                              <select
                                id="eneo"
                                className="form-control"
                                name="eneo"
                                onChange={getTerritoryIDChange}
                                value={territoryID}
                                required
                              >
                                <option value="">Chagua Eneo</option>
                                {territories.length > 0 &&
                                  territories?.map((territory) => (
                                    <option
                                      key={territory.id}
                                      value={territory.ResourceID}
                                    >
                                      {territory.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthRegionID"
                              >
                                Mkoa
                              </label>

                              <select
                                id="mkoa"
                                className="form-control"
                                onChange={getRegionIDChange}
                                value={regionsId}
                                name="mkoa"
                                required
                              >
                                <option value="">Chagua Mkoa</option>
                                {regions.length > 0 &&
                                  regions?.map((region) => (
                                    <option
                                      key={region.ResourceID}
                                      value={region.ResourceID}
                                    >
                                      {region.ResourceName}
                                    </option>
                                  ))}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthDistrictID"
                              >
                                Wilaya
                              </label>
                              <select
                                id="DistrictID"
                                className="form-control"
                                onChange={getDistrictIDChange}
                                value={districtsId}
                                name="DistrictID"
                                required
                              >
                                <option value="">Chagua Wilaya</option>
                                {districts.length > 0 &&
                                  districts?.map((district) => (
                                    <option
                                      key={district.ResourceID}
                                      value={district.ResourceID}
                                    >
                                      {district.ResourceName}
                                    </option>
                                  ))}{" "}
                              </select>
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group required">
                              <label
                                className="control-label"
                                htmlFor="BirthVillage"
                              >
                                Mtaa/Kijiji
                              </label>
                              <input
                                type="text"
                                id="BirthVillage"
                                className="form-control"
                                name="BirthVillage"
                                onChange={(e) =>
                                  setBirthVillage(e.target.value.toUpperCase())
                                }
                                value={BirthVillage}
                                required
                              />
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="control-label">
                                Nyumba Na.
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="HouseNumber"
                                onChange={(e) =>
                                  setHouseNumber(e.target.value.toUpperCase())
                                }
                                value={HouseNumber}
                                aria-required="true"
                              />
                              <p className="help-block help-block-error"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {errors && (
                        <div className="help-block help-block-error">
                          {Object.values(errors).map((error, index) => (
                            <p
                              className="help-block help-block-error"
                              key={index}
                            >
                              {error}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="box-footer">
                      <div className="row">
                        <div className="col-md-4">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              nyuma();
                            }}
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveBack"
                          >
                            <i className="fa fa-angle-double-left"></i> | Hatua
                            Iliyotangulia
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <Link
                            className="btn btn-labeled btn-block btn-default"
                            name="SaveExit"
                            onClick={(e) => {
                              e.preventDefault();
                              endeleaBadae();
                            }}
                          >
                            Hifadhi na Toka |{" "}
                            <i className="fa fa-save"></i>{" "}
                          </Link>
                        </div>
                        <div className="col-md-4">
                          <button
                            disabled={isLoading}
                            className="btn btn-default btn-block btn-label-next"
                            name="SaveNext"
                          >
                            {isLoading ? "Subiri.." : "Hifadhi na Endelea |"}{" "}
                            <i className="fa fa-angle-double-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default AnuaniYaSasa;
